<div class="fullcontainer pr-3">
  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Report - Same customer and site</h1>
    </div>

    <div class='row'>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' (click)='this.loadReport()'>Run Report</button>
    <hr />
    <button class='btn btn-secondary' (click)='exportToCSV()'>Export to CSV</button>
  </div>

  <div class='sheet'>
    @if (this.data.length > 0) {
      <div class='titleContainer'>
        <h1 class='header'>Results</h1>
        <!--   o.id as OrderId, a.name as AccountName, b.name as SiteName, order_status.name as Status -->
        <table class='table'>
          <thead>
            <th>Order ID</th>
            <th>Order Date</th>
            <th>Account Name</th>
            <th>Site Name</th>
            <th>Status</th>
            <th></th>
          </thead>
          <tbody>
            @for (item of this.data; track item) {
              <tr>
                <td>{{ item.OrderId }}</td>
                <td>{{ item.OrderDate | date: 'short' }}</td>
                <td>{{ item.AccountName }}</td>
                <td>{{ item.SiteName }}</td>
                <td>{{ item.Status }}</td>
                <td><button class='btn btn-warning' [routerLink]='"/orders/edit/" + item.OrderId'>View Order</button>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>